<app-menu></app-menu>

<div class="container my-shopping-item-page">
    <ng-container *ngIf="isLoading; else content">
        <div class="loading-spinner">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>

    <ng-template #content>
        <ng-container *ngIf="pedido">
            <div class="breadcrumb">
                <a routerLink="/minhas-compras" (click)="goBack()">Minhas Compras</a>
                <span>/</span>
                <span>Pedido #{{ pedido.idKitPayment }}</span>
            </div>

            <div class="order-header">
                <h1>{{ pedido.bookTitle }}</h1>
                <p>Pedido #{{ pedido.idKitPayment }}</p>
            </div>

            <div class="order-status" *ngIf="pedido.hasPhysicalBook == true">
                <h2>Status do pedido</h2>
                <div class="status-timeline">
                    <div class="status-item" [class.completed]="true">
                        <mat-icon>check_circle</mat-icon>
                        <span>Pago</span>
                    </div>
                    <div class="timeline-connector"></div>
                    <div class="status-item" [class.completed]="true">
                        <mat-icon>check_circle</mat-icon>
                        <span>Em produção</span>
                    </div>
                    <div class="timeline-connector"></div>
                    <div class="status-item" [class.completed]="pedido.isSend || pedido.isDelivered">
                        <mat-icon>check_circle</mat-icon>
                        <span>Enviado</span>
                        <a target="_blank" *ngIf="pedido.coreiosTrackingCode"
                            href="https://rastreamento.correios.com.br/app/index.php?obj={{pedido.coreiosTrackingCode}}">Correios:
                            {{pedido.coreiosTrackingCode}}</a>
                    </div>
                    <div class="timeline-connector"></div>
                    <div class="status-item" [class.completed]="pedido.isDelivered">
                        <mat-icon>check_circle</mat-icon>
                        <span>Entregue</span>
                    </div>
                </div>
            </div>

            <div class="order-details-section">
                <h2>Detalhes do pedido</h2>
                <div class="details-item">
                    <img [src]="pedido.bookCoverImageUrl" alt="Capa do Livro" class="item-cover">
                    <div class="item-info">
                        <p class="item-title">
                            <span *ngIf="pedido.hasPhysicalBook">Livro</span>
                            <span *ngIf="pedido.hasPhysicalBook && pedido.hasEbook"> + </span>
                            <span *ngIf="pedido.hasEbook">ebook</span>
                        </p>
                        <p class="item-description">{{ pedido.bookTitle }}</p>
                    </div>
                </div>
                <div class="details-item" *ngIf="pedido.hasVideoContent">
                    <img [src]="pedido.bookCoverImageUrl" alt="Video Aula" class="item-cover">
                    <div class="item-info">
                        <p class="item-title">Video aula</p>
                        <p class="item-description">Conteúdo em vídeo</p>
                    </div>
                </div>
            </div>

            <div class="order-summary-grid">
                <div class="info-card">
                    <mat-icon>credit_card</mat-icon>
                    <span>{{ pedido.paymentType }} - {{ pedido.paymentInstallment }}</span>
                </div>
                <div class="info-card">
                    <mat-icon>inventory_2</mat-icon>
                    <span>{{ pedido.quantity }} item</span>
                </div>
                <div class="info-card" *ngIf="pedido.hasPhysicalBook">
                    <mat-icon>local_shipping</mat-icon>
                    <span>Entrega {{ pedido.deliveredType }}</span>
                </div>
                <div class="info-card address-card" *ngIf="pedido.hasPhysicalBook">
                    <mat-icon>location_on</mat-icon>
                    <span>{{ pedido.addressComplete }}</span>
                </div>
                <div class="info-card date-card">
                    <mat-icon>calendar_today</mat-icon>
                    <span>Comprado em {{ pedido.datetimeInclusion | date:'dd \'de\' MMMM \'de\' yyyy \'às\' HH:mm'
                        }}</span>
                </div>
            </div>

            <div class="order-summary-total">
                <h2>Resumo do pedido</h2>
                <div class="summary-line">
                    <span>Subtotal</span>
                    <span>{{ pedido.paymentFinalValue | currency:'BRL' }}</span>
                </div>
                <div class="summary-line">
                    <span>Frete</span>
                    <span>{{ pedido.paymentDeliveredValue > 0 ? (pedido.paymentDeliveredValue | currency:'BRL') :
                        'Grátis' }}</span>
                </div>
                <div class="summary-line total">
                    <span>Total</span>
                    <span>{{ (pedido.paymentFinalValue + pedido.paymentDeliveredValue) | currency:'BRL' }}</span>
                </div>
            </div>

            <button mat-flat-button class="back-button" (click)="goBack()">Voltar para Minhas compras</button>

        </ng-container>
    </ng-template>
</div>

<app-footer></app-footer>